<link rel="stylesheet" href="//cdn.jsdelivr.net/npm/xeicon@2.3.3/xeicon.min.css">
<article>
    <h1>알림</h1>

    <div class="btn-box">
        <button class="delete" (click)="delete()">삭제</button>
        <button class="write" (click)="edit(null)">작성</button>
    </div>

    <div class="dash-board">
        <table>
            <thead>
                <tr>
                    <th><button class="check-box" [ngClass]="{'on': selectedFlag}" (click)="selectedAll()"></button></th>
                    <th>번호</th>
                    <th>제목</th>
                    <th>등록일</th>
                    <th>편집</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor = "let notice of notices | slice: currentPage*10:currentPage*10+10; let i =index">
                    <td><button class="check-box" [ngClass]="{'on': notice.selected}" (click)="checked(notice)"></button></td>
                    <td>{{i+1 + currentPage*10}}</td>
                    <td>{{notice.title}}</td>
                    <td>{{notice.creationDate|date :'yyyy-MM-dd'}}</td>
                    <td> <button><img src="/assets/images/btn-edit.png" alt="편집" (click)="edit(notice)"></button></td>
                </tr>
            </tbody>
        </table>

        <div class="page-number">
            <button class="btn"><img src="/assets/images/btn-previous-2.png" alt="버튼"></button>
            <button class="btn" (click)="prevPage()" ><img src="/assets/images/btn-previous.png" alt="버튼"></button>

            <button class="btn number" *ngFor="let page of pages; let i = index" [ngClass]="{'on': page.selected}" (click)="selectNumber(page,i)">{{i+1}}</button>

            <button class="btn"  (click)="nextPage()"><img src="/assets/images/btn-next.png"alt="버튼"></button>
            <button class="btn"><img src="/assets/images/btn-next-2.png" alt="버튼"></button>
        </div>

    </div>
</article>